"use client";

import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Link from "next/link";
import Image from "next/image";
import ServicedevelopmentCards from "../development-financing/page";

const services = [
  {
    title: "Micro Loans",
    image: "/projects/profile.jpg",
    description:
      "Tailored small-scale financing solutions designed to empower entrepreneurs and small businesses.",
    lists: [
      "Working capital loans",
      "Equipment financing",
      "Trade credit facilities",
    ],
    details:
      "Our micro loans feature flexible repayment terms, competitive interest rates, and quick approval processes to support your business growth and operational needs.",
  },
  {
    title: "Agricultural Financing",
    image: "/projects/profile2.jpg",
    description:
      "Specialized financial products for farmers and agribusinesses to boost productivity.",
    lists: [
      "Seasonal crop financing",
      "Livestock loans",
      "Irrigation equipment loans",
    ],
    details:
      "We offer customized agricultural loans with crop-cycle aligned repayment schedules, input financing, and technical support to enhance farm productivity and sustainability.",
  },
];

const otheryegna = [
  {
    title: "Special Property Loan",
    description:
      "This loan is designed for employees of YMFI's strategic partners, offering a lower interest rate than conventional fixed asset loans. Loan terms range from 12 to 60 months, with monthly or quarterly repayments.",
    image: "/projects/special22.jpg",
  },
  {
    title: "Commitment Loan",
    description:
      "The Commitment loan is designed to finance the purchase of assets such as vehicles, houses or to utilize the loan to other personal consumption. This loan caters to clients who intend to save and deposit a portion of the loan amount over five months before asset acquisition. Clients must commit to depositing between 20% to 50% of the loan amount over five months in advance or on regular monthly deposit manner. The loan is available to individuals or organizations.",
    image: "/projects/commitment.jpg",
  },
  {
    title: "Fixed Asset Purchase Loan",
    description:
      "Yegna MFI Offers to middle-income borrowers for buying fixed assets like vehicles, electronics and household equipment.",
    image: "/projects/fixedasset12.jpg",
  },
];

const projects = [
  {
    title: "Micro Business Loan",
    description:
      "Micro Business Loans-It aims to support both the creation of new businesses and the expansion of existing ones. These loans have a social objective, focusing on empowering micro enterprises by tailoring products to their needs. The target groups include business owners in rural and urban micro businesses.",
    image: "/projects/microbuisness.png",
  },
  {
    title: "SME Loan",
    description:
      "SME Loan designed to support new or existing SMEs in urban and rural areas, covering working capital and general business needs.",
    image: "/projects/smallbuisness222.jpeg",
  },
  {
    title: "Housing, Construction & Renovation Loan",
    description:
      "This loan is intended to assist eligible borrowers with the following purposes: Completing construction or renovation of buildings, Partial settlement of the purchase price for condominiums, Construction of small shops, Expanding or adding classrooms and other related construction and renovation needs.",
    image: "/projects/housing.jpg",
  },
  {
    title: "Special Emergency Loan",
    description:
      "The Special Emergency Loan provides short-term financing to address urgent financial needs. This loan is intended to support: Importers Contractors (e.g., for salary payments, customs payments) Any other business requiring immediate financing with a short-term return",
    image: "/projects/importer.jpg",
  },
];

// Clean color palette - Only Deep Teal Green and White
const colors = {
  primary: "#395750",      // Deep Teal Green - Company color
  primaryDark: "#2A423C",  // Darker teal
  primaryLight: "#4B6B63", // Lighter teal
  white: "#FFFFFF",        // White
  whiteOff: "#F8F9FA",     // Off-white for subtle contrast
  textDark: "#1A2E29",     // Dark text for contrast
};

const text = "Tailored Personal Loans & Financial Solutions";

export default function ServiceloanCards() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setCurrentIndex((prev) => prev + 1);
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [currentIndex]);

  return (
    <div className="mt-30 mb-20 space-y-16 pt-28 overflow-x-hidden sm:pt-10 md:pt-6 lg:pt-0">
      {/* Projects Section */}
      <div className="mt-2 px-4 lg:mx-auto lg:max-w-[1500px]" id="projects">
        <div className="py-5">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-16 text-center text-4xl font-bold sm:text-5xl"
            style={{ color: colors.primary }}
          >
            <span className="relative inline-block">
              <span className="bg-gradient-to-r bg-clip-text text-transparent" style={{ backgroundImage: `linear-gradient(to right, ${colors.primary}, ${colors.primaryLight})` }}>
                Loan Products
              </span>
              <motion.span
                className="absolute bottom-0 left-0 h-1 w-full bg-gradient-to-r"
                style={{ background: `linear-gradient(to right, ${colors.primary}, ${colors.primaryLight})` }}
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 0.8, delay: 0.3 }}
              />
            </span>
          </motion.h2>

          <div className="relative">
            {/* Decorative background elements */}
            <div className="absolute -left-20 top-1/4 h-64 w-64 rounded-full opacity-50 blur-xl" style={{ backgroundColor: `${colors.primary}10` }}></div>
            <div className="absolute -right-20 bottom-1/4 h-48 w-48 rounded-full opacity-20 blur-xl" style={{ backgroundColor: `${colors.primaryLight}30` }}></div>

            <div className="space-y-32">
              {projects.map((project, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true, margin: "-100px" }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="relative z-10"
                >
                  {/* Timeline indicator */}
                  <div className="absolute left-1/2 top-0 hidden h-full w-0.5 -translate-x-1/2 transform md:block" style={{ background: `linear-gradient(to bottom, transparent, ${colors.primary}, transparent)` }}></div>

                  <div className="flex flex-col items-center md:flex-row md:items-stretch">
                    {/* Image column */}
                    <motion.div
                      className="relative md:w-5/12"
                      initial={{ x: -50, opacity: 0 }}
                      whileInView={{ x: 0, opacity: 1 }}
                      transition={{ duration: 0.6 }}
                    >
                      <div className="relative aspect-video overflow-hidden rounded-xl shadow-2xl" style={{ border: `4px solid ${colors.white}` }}>
                        <Image
                          src={project.image}
                          alt={project.title}
                          fill
                          className="object-cover transition-all duration-500 hover:scale-105"
                        />
                        <div className="absolute inset-0" style={{ background: `linear-gradient(to top, ${colors.primary}30, transparent)` }}></div>
                      </div>
                      <motion.div
                        className="absolute -bottom-6 -left-6 h-16 w-16 rounded-full"
                        style={{ backgroundColor: `${colors.primaryLight}20` }}
                        initial={{ scale: 0 }}
                        whileInView={{ scale: 1 }}
                        transition={{ delay: 0.4 }}
                      />
                    </motion.div>

                    {/* Spacer column */}
                    <div className="hidden w-1/12 md:block"></div>

                    {/* Content column */}
                    <motion.div
                      className="mt-8 md:mt-0 md:w-6/12"
                      initial={{ x: 50, opacity: 0 }}
                      whileInView={{ x: 0, opacity: 1 }}
                      transition={{ duration: 0.6, delay: 0.2 }}
                    >
                      <div className="relative rounded-lg p-8 shadow-lg" style={{ backgroundColor: colors.white, boxShadow: `0 10px 40px -15px ${colors.primary}30` }}>
                        <motion.h3
                          className="text-3xl font-bold"
                          style={{ color: colors.primary }}
                          initial={{ opacity: 0 }}
                          whileInView={{ opacity: 1 }}
                          transition={{ delay: 0.3 }}
                        >
                          {project.title}
                        </motion.h3>

                        <motion.div
                          className="my-4 h-1 w-16"
                          style={{ background: `linear-gradient(to right, ${colors.primary}, ${colors.primaryLight})` }}
                          initial={{ scaleX: 0 }}
                          whileInView={{ scaleX: 1 }}
                          transition={{ delay: 0.4 }}
                        />

                        <motion.p
                          className="mb-6 text-lg"
                          style={{ color: colors.textDark }}
                          initial={{ opacity: 0 }}
                          whileInView={{ opacity: 1 }}
                          transition={{ delay: 0.5 }}
                        >
                          {project.description}
                        </motion.p>

                        <div className="mb-8 flex flex-wrap gap-3">
                          {[
                            `12-36 months`,
                            `Competitive rates`,
                            `Flexible terms`,
                            `Quick approval`,
                          ].map((item, i) => (
                            <motion.span
                              key={i}
                              className="rounded-full px-4 py-1.5 text-sm font-medium"
                              style={{ backgroundColor: `${colors.primary}10`, color: colors.primary }}
                              initial={{ scale: 0 }}
                              whileInView={{ scale: 1 }}
                              transition={{ delay: 0.6 + i * 0.1 }}
                            >
                              {item}
                            </motion.span>
                          ))}
                        </div>
                      </div>
                    </motion.div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Development & Asset Loans Section */}
      <div className="mt-20 px-4 lg:mx-auto lg:max-w-[1500px]" id="special-loans">
        <div className="py-10">
          <div className="mt-16 space-y-28">
            {otheryegna.map((loan, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={`flex flex-col ${index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"} gap-10 md:gap-16`}
              >
                {/* Image Section */}
                <motion.div
                  className="group relative md:w-1/2"
                  whileHover={{ scale: 0.98 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="relative aspect-video overflow-hidden rounded-xl shadow-lg">
                    <Image
                      src={loan.image}
                      alt={loan.title}
                      fill
                      className="object-cover grayscale transition-all duration-500 group-hover:scale-105 group-hover:grayscale-0"
                    />
                    <div className="pointer-events-none absolute inset-0" style={{ background: `linear-gradient(to bottom, transparent, transparent, ${colors.primary}20)` }} />
                  </div>
                  <motion.div
                    className="absolute -bottom-4 -left-4 h-16 w-16 rounded-full"
                    style={{ backgroundColor: `${colors.primaryLight}20` }}
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    transition={{ delay: 0.4 }}
                  />
                  <motion.div
                    className="absolute -right-4 -top-4 h-12 w-12 rounded-lg"
                    style={{ backgroundColor: `${colors.primary}20` }}
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    transition={{ delay: 0.6 }}
                  />
                </motion.div>

                {/* Content Section */}
                <motion.div
                  className="md:w-1/2"
                  initial={{ x: index % 2 === 0 ? 50 : -50 }}
                  whileInView={{ x: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  <div className="flex items-start">
                    <motion.div
                      className="mr-4 h-8 w-1"
                      style={{ background: `linear-gradient(to bottom, ${colors.primary}, ${colors.primaryLight})` }}
                      initial={{ scaleY: 0 }}
                      whileInView={{ scaleY: 1 }}
                      transition={{ duration: 0.5 }}
                    />
                    <div>
                      <motion.h3
                        className="text-3xl font-bold"
                        style={{ color: colors.primary }}
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ delay: 0.2 }}
                      >
                        {loan.title}
                      </motion.h3>
                      <motion.div
                        className="mt-3 h-1 w-16"
                        style={{ background: `linear-gradient(to right, ${colors.primary}, ${colors.primaryLight})` }}
                        initial={{ scaleX: 0 }}
                        whileInView={{ scaleX: 1 }}
                        transition={{ delay: 0.4 }}
                      />
                    </div>
                  </div>

                  <motion.p
                    className="mt-6 text-lg"
                    style={{ color: colors.textDark }}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ delay: 0.3 }}
                  >
                    {loan.description}
                  </motion.p>

                  <motion.div
                    className="mt-8"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ delay: 0.5 }}
                  >
                    <div className="flex flex-wrap gap-3">
                      {[
                        `Terms: 12-36 months`,
                        `Collateral: Flexible`,
                        `Repayment: Monthly`,
                      ].map((item, i) => (
                        <motion.span
                          key={i}
                          className="rounded-full px-4 py-1.5 text-sm font-medium"
                          style={{ backgroundColor: `${colors.primary}10`, color: colors.primary }}
                          initial={{ scale: 0 }}
                          whileInView={{ scale: 1 }}
                          transition={{ delay: 0.2 + i * 0.1 }}
                          whileHover={{ scale: 1.05 }}
                        >
                          {item}
                        </motion.span>
                      ))}
                    </div>
                  </motion.div>
                </motion.div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}